import { ArrowRightIcon } from "./Icons";

const steps = [
  {
    number: "01",
    title: "Ceritakan kebutuhan",
    copy: "Kirim ide, sketsa, foto referensi, atau file 3D.",
  },
  {
    number: "02",
    title: "Review & estimasi",
    copy: "Kami cek desain, material, waktu, dan biaya.",
  },
  {
    number: "03",
    title: "Produksi",
    copy: "Setelah disetujui, proyek masuk proses desain dan cetak.",
  },
  {
    number: "04",
    title: "Kirim & evaluasi",
    copy: "Produk diperiksa lalu dikirim atau disiapkan untuk revisi.",
  },
] as const;

const projects = [
  {
    className: "project-featured",
    image: "/images/work-enclosure.webp",
    alt: "Prototype enclosure berwarna koral hasil 3D printing",
    width: 1448,
    height: 1086,
    label: "Prototype enclosure",
  },
  {
    className: "project-secondary",
    image: "/images/work-architecture.webp",
    alt: "Miniatur arsitektur rumah tropis hasil 3D printing",
    width: 1672,
    height: 941,
    label: "Miniatur arsitektur",
  },
  {
    className: "project-secondary",
    image: "/images/work-bracket.webp",
    alt: "Part custom berupa mounting bracket hitam hasil 3D printing",
    width: 1672,
    height: 941,
    label: "Part custom",
  },
] as const;

export function ProcessWork() {
  return (
    <section className="process-work" id="cara-kerja" aria-labelledby="process-title">
      <div className="container">
        <div className="process-heading" data-reveal>
          <h2 id="process-title">Cara kerja kami.</h2>
          <p>Proses sederhana, hasil yang bisa kamu pegang.</p>
        </div>

        <ol className="process-list" data-reveal>
          {steps.map((step) => (
            <li key={step.number}>
              <div className="process-number-line">
                <span>{step.number}</span>
                <span className="process-line" aria-hidden="true" />
              </div>
              <h3>{step.title}</h3>
              <p>{step.copy}</p>
            </li>
          ))}
        </ol>

        <div className="work-heading" id="karya" data-reveal>
          <h2>Dipilih dari meja kerja.</h2>
          <a className="button button-primary" href="#order">
            Mulai proyek serupa
            <ArrowRightIcon />
          </a>
        </div>

        <div className="project-grid" data-reveal>
          {projects.map((project) => (
            <figure className={project.className} key={project.label}>
              <div className="project-image-wrap">
                <img
                  alt={project.alt}
                  height={project.height}
                  loading="lazy"
                  src={project.image}
                  width={project.width}
                />
              </div>
              <figcaption>{project.label}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
